import localeMessages from '@/locales'
import { helper } from '@heyform-inc/utils'
import { useRouter } from 'next/router'
import objectPath from 'object-path'

export function useLocale() {
  const { locale, locales, defaultLocale } = useRouter()
  const supportedLocales = Array.isArray(locales)
    ? locales
    : Object.keys(localeMessages)
  const fallbackLocale = defaultLocale || supportedLocales[0] || 'en'

  if (locale && supportedLocales.includes(locale)) {
    return locale
  }

  return fallbackLocale
}

export function useTranslation() {
  return (token: string, replacements?: Record<string, any>) => {
    const locale = useLocale()
    const messages =
      localeMessages[locale] ||
      localeMessages[Object.keys(localeMessages)[0]] ||
      {}
    let translation = objectPath.get(messages, token)

    if (helper.isValid(translation)) {
      // Replace placeholders
      if (helper.isValid(replacements) && helper.isPlainObject(replacements)) {
        Object.keys(replacements).forEach(key => {
          const regex = new RegExp(`{${key}}`, 'g')
          translation = translation.replace(regex, replacements[key])
        })
      }

      return translation
    }

    return token
  }
}

export function useLink(href: string) {
  const locale = useLocale()
  const { defaultLocale } = useRouter()
  const fallbackDefaultLocale = defaultLocale || locale

  return urlBuilder(href, locale, fallbackDefaultLocale)
}

export function urlBuilder(
  href: string,
  locale: string,
  defaultLocale: string
) {
  // Canonical and OG URLs should use the clean path only, without tracking params.
  href = href.split('#')[0].split('?')[0]

  if (!href.startsWith('/')) {
    href = '/' + href
  }

  const safeLocale = (locale || '').toLowerCase()
  const safeDefaultLocale = (defaultLocale || '').toLowerCase()

  if (safeLocale && safeDefaultLocale && safeLocale !== safeDefaultLocale) {
    href = '/' + locale + href
  }

  // Remove trailing slash
  href = href.replace(/\/$/, '')

  return process.env.NEXT_PUBLIC_WEBSITE_URI.replace(/\/$/, '') + href
}
